export const hrefToSitecoreLink = (href) => {
  if (typeof href === 'object') {
    return {
      value: href,
    };
  } else {
    return {
      value: {
        href: href,
        url: href,
      },
    };
  }
};
